import { toRaw } from 'vue'
import AuthMixin from '@/components/mixins/auth-mixin'
import MediaScheduleMixin from '@/components/mixins/media-schedule-mixin'
import PlaytimeForm from './playtime-form/playtime-form-tmpl'
import EventBus from '@/components/mixins/event-bus-mixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'schedulePlaytime',
  inject: [
    '$utils',
    '$dataStore',
    '$api',
    '$apiError'
  ],
  components: { PlaytimeForm },
  props: {
    mediaSelectionProp: {
      default () { return [] }
    },
    parentAccessorComponentProp: {
      type: String,
      default () { return 'mediaPage' }
    },
    mediaPropertiesFormDataProp: {
      type: Object,
      default () { return {} }
    }
  },
  watch: {
    mediaPropertiesFormDataProp (newVal, prevVal) {
      const currentSelectedScheduleTarget = newVal.values.scheduleSelection
      const previousSelectedScheduleTarget = prevVal.values.scheduleSelection
      const previousPlaytimeTarget = prevVal.values.schedulePlaytimeTarget
      const newPlaytimeTarget = newVal.values.schedulePlaytimeTarget
      let isScheduleTargetChanged = false
      let isSchedulePlaytimeTargetChanged = false

      if ((currentSelectedScheduleTarget.length > 0 && previousSelectedScheduleTarget.length > 0) &&
        (currentSelectedScheduleTarget.length !== previousSelectedScheduleTarget.length)) {
        isScheduleTargetChanged = true
      } else if ((currentSelectedScheduleTarget.length === 1 && previousSelectedScheduleTarget.length === 1) && (newVal.values.scheduleSelection[0].target !== prevVal.values.scheduleSelection[0].target)) {
        isScheduleTargetChanged = true
      }

      if (previousPlaytimeTarget.length !== newPlaytimeTarget.length) {
        isSchedulePlaytimeTargetChanged = true
      } else if ((previousPlaytimeTarget.length && newPlaytimeTarget.length) && (JSON.stringify(previousPlaytimeTarget.sort()[0]) !== JSON.stringify(newPlaytimeTarget.sort()[0]))) {
        isSchedulePlaytimeTargetChanged = true
      }

      if (isScheduleTargetChanged || isSchedulePlaytimeTargetChanged) {
        this.handleMediaPropertiesFormDataChangedFromParent(newVal)
      }
    },
    mediaSelectionProp: {
      handler (newVal, prevVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(prevVal)) {
          this.handleMediaPropertiesFormDataChangedFromParent(this.mediaPropertiesFormDataProp)
        }
      },
      deep: true
    },
    playtimeFormat () {
      this.scheduleTimeList = this.filterScheduleTimeList(this.scheduleTimeList)
    }
  },
  computed: {
    hideNewScheduleButton () {
      let res = false

      if ((this.componentUsedInPlayersPageMenu || this.omponentUsedInProjectTemplateMenu) && this.scheduleTimeList.length >= 5) {
        res = true
      }

      return res
    },
    schedulePlaytimeWrapperExtraClassname () {
      let res = ''

      if (this.componentUsedInPlayersPageMenu) res = 'player-playtimes'
      if (this.omponentUsedInProjectTemplateMenu) res = 'project-template-playtimes'

      return res
    },
    ...mapGetters({
      playtimeFormat: 'preferredTimeFormat'
    })
  },
  mixins: [AuthMixin, MediaScheduleMixin],
  data () {
    return {
      playtimeItemsVisible: 'all',
      mediaSelection: this.mediaSelectionProp,
      parentAccessorComponent: this.parentAccessorComponentProp,
      componentUsedInSchedulePage: this.parentAccessorComponentProp === 'schedulePage',
      componentUsedInPlayersPageMenu: this.parentAccessorComponentProp === 'playersPageMenu',
      omponentUsedInProjectTemplateMenu: this.parentAccessorComponentProp === 'projectTemplateMenu',
      mediaPropertiesForm: this.mediaPropertiesFormDataProp,
      showNewPlayTimeForm: false,
      scheduleTypeOptions: { daily: 'daily', custom: 'custom' },
      selectedScheduleTarget: [],
      selectedPlaytimeItem: null,
      formValues: {
        startDateAndEndDate: [],
        type: null,
        startTime: '',
        endTime: '',
        repeatDays: [],
        showDateRange: false,
        showTimeRange: false
      },
      scheduleTimeListActions: { createNewPlayTime: 'createNewPlayTime', updatePlayTime: 'updatePlayTime', deletePlayTime: 'deletePlayTime' },
      scheduleTimeList: [],
      informPlaytimeFormToSendChanges: { send: false, ref: null },
      timeTagShowSelectbox: false,
      timeTagList: [],
      timeTagGetStatus: false,
      timeTagInitialLoad: false,
      timeTagNewValue: null
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('schedule-playtime-menu-item-change', { action, payload: { data } })
      }
    },
    handleMediaPropertiesFormDataChangedFromParent (newVal) {
      this.mediaPropertiesForm = this.$utils.clone(newVal)

      const singleScheduleTargetSelected = newVal.values.scheduleSelection.length === 1
      const multiScheduleTargetSelected = newVal.values.scheduleSelection.length > 1

      // Single Schedule target selection
      if (singleScheduleTargetSelected) {
        const selectedSchedule = newVal.values.scheduleSelection[0]

        this.scheduleTimeList = []
        this.selectedPlaytimeItem = null
        if (typeof selectedSchedule === 'object') {
          const newScheduleTimeList = selectedSchedule.custom
          this.selectedScheduleTarget = [selectedSchedule.target]
          this.playtimeItemsVisible = newVal.values.playtimeItemsVisible
          this.scheduleTimeList = this.filterScheduleTimeList(newScheduleTimeList)

          // Auto select playtime
          if (newVal.values.schedulePlaytimeTarget.length) {
            const schedulePlaytimeTarget = newVal.values.schedulePlaytimeTarget[0]

            let targetPlaytime = this.scheduleTimeList.find((playtime) => { return playtime.uid === schedulePlaytimeTarget.uid })
            if (targetPlaytime < 0) {
              targetPlaytime = this.scheduleTimeList.find((playtime) => { return playtime.order === schedulePlaytimeTarget.order })
            }
            if (targetPlaytime) {
              this.handlePlayTimeSelection(targetPlaytime)
            }
          }
        }
      }

      // Multiple Schedule target selection
      if (multiScheduleTargetSelected) {
        const newMediaPropData = this.$utils.clone(newVal)
        const getCustomPlaytimeSummary = (customData) => {
          const playtimesSummary = []

          for (const playtime of customData) {
            delete playtime.uid
            delete playtime.order
            delete playtime._edit
            delete playtime.multi
            delete playtime.tag

            if ('startTime' in playtime && !playtime.startTime) {
              playtime.startTime = '00:00:00'
            }

            for (const indx in playtime) {
              if (Array.isArray(playtime[indx])) playtime[indx].sort()
              playtimesSummary.push(playtime[indx])
            }
          }
          return JSON.stringify(playtimesSummary.sort())
        }
        const playtimesSrc = getCustomPlaytimeSummary(this.$utils.clone(newMediaPropData.values.scheduleSelection[0].custom))

        let countDifference = 0
        newMediaPropData.values.scheduleSelection.forEach((schedule, indx) => {
          if (indx > 0) {
            const customPlaytimes = getCustomPlaytimeSummary(schedule.custom)

            if (playtimesSrc !== customPlaytimes) {
              countDifference = Math.max(0, countDifference) + 1
            } else if (playtimesSrc === customPlaytimes) {
              countDifference = Math.max(0, countDifference) - 1
            }
          }
        })

        // Set playtime list
        let newScheduleTimeList = []
        if (countDifference <= 0) newScheduleTimeList = newVal.values.scheduleSelection[0].custom
        this.scheduleTimeList = this.filterScheduleTimeList(newScheduleTimeList)

        // Set schedule target
        const selectedScheduleTarget = newVal.values.scheduleSelection.map(schedule => schedule.target)
        this.selectedScheduleTarget = selectedScheduleTarget

        // Auto select if there are one playtime
        this.selectedPlaytimeItem = null
        if (this.scheduleTimeList.length === 1 && this.selectedPlaytimeItem === null) {
          this.handlePlayTimeSelection(this.scheduleTimeList[0])
        }
      }

      // Need to pass this data into parent component for new added player
      this.emitEvent('PLAYTIMES_BEFORE_UPDATE', {
        scheduleTarget: this.selectedScheduleTarget,
        playtimes: this.scheduleTimeList
      })
    },
    filterScheduleTimeList (scheduleTimeListSrc, addParams) {
      const scheduleTimeList = this.$utils.clone(scheduleTimeListSrc)
      if (!addParams) addParams = {}

      scheduleTimeList.forEach((scheduleTime, indx) => {
        if (!scheduleTime.order) {
          scheduleTime.order = this.$utils.calculateSortOrderValue()
        }

        if (!scheduleTime._edit) {
          scheduleTime._edit = { itemKey: `${scheduleTime.order}_${indx}` }
        }

        if (!scheduleTime._edit.isVisible) {
          scheduleTime._edit.isVisible = true
        }

        // Create playtime title
        scheduleTime._edit.title = this.createScheduleTimeTitle(scheduleTime, { timeFormat: this.playtimeFormat }).range

        // Hide playtime
        if (Array.isArray(this.playtimeItemsVisible) && this.playtimeItemsVisible.indexOf(scheduleTime.uid) < 0) {
          scheduleTime._edit.isVisible = false
        }

        // Add backgroundColor
        if (addParams.addBackgroundColor) {
          scheduleTime._edit.backgroundColor = addParams.addBackgroundColor
        }
      })

      return scheduleTimeList
    },
    filterTimeTagOptions (timeTagsSrc) {
      let timeTags = this.$utils.clone(timeTagsSrc)

      // Add empty tag
      timeTags.push({})

      // Filter time tags the same as time list to get the title
      timeTags = this.filterScheduleTimeList(timeTags, { addBackgroundColor: '#d4d4d4' })

      // Adjust empty tag title
      timeTags[timeTags.length - 1]._edit.title = '●●●'
      timeTags[timeTags.length - 1]._edit.emptyTimeTag = true

      return timeTags
    },
    handleNewTimeTagChange () {
      const timeTagNewValue = this.$utils.clone(this.timeTagNewValue)
      const isEmptyTimeTag = timeTagNewValue._edit.emptyTimeTag
      let scheduleTimeList = this.$utils.clone(this.scheduleTimeList)

      timeTagNewValue.uid = this.$utils.generateUniqueID()
      timeTagNewValue.order = this.$utils.calculateSortOrderValue({ playtimeIndex: scheduleTimeList.length + 1 })

      // Add to current schedule list
      scheduleTimeList.push(timeTagNewValue)
      scheduleTimeList = this.filterScheduleTimeList(scheduleTimeList)

      // Adjust title for empty time tag in the list
      const newAddedTime = scheduleTimeList[scheduleTimeList.length - 1]
      if (isEmptyTimeTag) {
        newAddedTime._edit.title = '●●●'

        if (this.componentUsedInPlayersPageMenu) {
          newAddedTime._edit.title = 'empty'
        }
      }

      // Update current schedule time list
      this.scheduleTimeList = scheduleTimeList

      // Auto select newly added time
      let autoSelectNewlyAddedTime = true
      if (this.componentUsedInPlayersPageMenu && !isEmptyTimeTag) {
        autoSelectNewlyAddedTime = false
      }
      if (autoSelectNewlyAddedTime) {
        this.handlePlayTimeRowClick(newAddedTime)
      }

      // As if playtime form changed just to send new playtimes into parent component
      if (!isEmptyTimeTag) {
        const formChangeParams = {
          action: 'PLAYTIME_FORM_UPDATED',
          payload: {
            data: {
              playtimeData: newAddedTime,
              domEvent: 'addNewPlaytimeButtonClick'
            }
          }
        }

        formChangeParams.payload.data.selectedPlayTime = newAddedTime

        this.handlePlaytimeFormChange(formChangeParams)
      }

      // Close new time tag selectbox
      this.timeTagNewValue = null
      this.timeTagShowSelectbox = false
    },
    handleScheduleTimeListData (actionType, selectedPlayTime, updatedPlayTimeData, domEvent) {
      let scheduleTimeList = this.$utils.clone(this.scheduleTimeList)

      // Create New Play Time
      if (actionType === this.scheduleTimeListActions.createNewPlayTime) {
        const newPlayTime = selectedPlayTime

        // Make sure no the same playtime uid
        const hasTheSameUID = scheduleTimeList.find((playtime) => { return playtime.uid === newPlayTime.uid })
        if (!hasTheSameUID) {
          scheduleTimeList.push(newPlayTime)

          if (Array.isArray(this.playtimeItemsVisible)) {
            this.playtimeItemsVisible.push(newPlayTime.uid)
          }
        }
      }

      // Delete Play Time
      if (actionType === this.scheduleTimeListActions.deletePlayTime) {
        scheduleTimeList = this.$utils.deleteItemFromList(scheduleTimeList, selectedPlayTime, 'uid')
        this.selectedPlaytimeItem = null
        domEvent = 'removePlaytimeIconClick'
      }

      // Update playtime item in the list
      if (actionType === this.scheduleTimeListActions.updatePlayTime) {
        scheduleTimeList = this.$utils.updateItemFromList(scheduleTimeList, updatedPlayTimeData, 'uid')
      }

      this.emitEvent('PLAYTIMES_UPDATED', {
        scheduleTarget: this.selectedScheduleTarget,
        playtimes: scheduleTimeList,
        actionType,
        domEvent
      })

      this.scheduleTimeList = this.filterScheduleTimeList(scheduleTimeList)
    },
    handleNewScheduleClick () {
      this.timeTagShowSelectbox = true

      const autoSelectEmptyTimeTag = () => {
        if (this.timeTagList.length === 1) {
          this.timeTagNewValue = this.timeTagList[0]
          this.handleNewTimeTagChange()
          this.timeTagShowSelectbox = false
        }
      }
      const autoFocusSelectBox = () => {
        if (this.timeTagList.length > 1) {
          this.$nextTick(() => {
            this.$refs.timeTagSelectbox.focus()
          })
        }
      }

      // Get Time Tags
      if (!this.timeTagInitialLoad) {
        const getTimeTags = () => {
          this.timeTagGetStatus = true

          const params = { type: 'timeTags' }
          this.$api.get(`${CONFIG.API_BASE_URL}/group/tags`, { params })
            .then(response => {
              this.timeTagGetStatus = false
              this.timeTagList = this.filterTimeTagOptions(response.data)
              this.timeTagInitialLoad = true

              // Auto select empty time tag
              autoSelectEmptyTimeTag()
              autoFocusSelectBox()
            })
            .catch((error) => {
              this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { getTimeTags() } })
            })
        }
        getTimeTags()
      } else {
        autoSelectEmptyTimeTag()
        autoFocusSelectBox()
      }

      if (this.componentUsedInPlayersPageMenu) {
        const playtimeFormEl = $('#playtimeForm')
        if (playtimeFormEl.length > 0) this.closePlaytimeForm()
      }
    },
    handlePlayTimeSelection (time) {
      time._edit.playerSelection = []
      this.$utils.clone(this.mediaPropertiesForm.values.scheduleSelection).forEach((player) => { time._edit.playerSelection.push(player.target) })
      time._edit.playerSelection.sort().join(',')

      this.selectedPlaytimeItem = null
      this.showNewPlayTimeForm = false

      this.$nextTick(() => {
        this.selectedPlaytimeItem = time
      })
    },
    handlePlayTimeRowClick (time) {
      this.handlePlayTimeSelection(toRaw(time))
      EventBus.$emit('MEDIA_MENU_SCHEDULE_PLAYTIME_SELECTED', {
        data: toRaw(time),
        type: 'newSchedulePlaytimeClicked'
      })
    },
    handlePlaytimeFormChange (event) {
      if (event.action === 'PLAYTIME_FORM_UPDATED') {
        const newPlayTime = event.payload.data.playtimeData
        const domEvent = event.payload.data.domEvent ? event.payload.data.domEvent : null

        // Update playtime
        let playtime = this.selectedPlaytimeItem
        if (!playtime && (event.payload.data && event.payload.data.selectedPlayTime)) {
          playtime = event.payload.data.selectedPlayTime
        }

        if (playtime) {
          const updatedPlaytimeItem = newPlayTime
          updatedPlaytimeItem.uid = playtime.uid
          updatedPlaytimeItem.order = playtime.order
          updatedPlaytimeItem.tag = playtime.tag
          updatedPlaytimeItem.multi = playtime.multi
          updatedPlaytimeItem.adds = playtime.adds

          this.handleScheduleTimeListData(this.scheduleTimeListActions.updatePlayTime, playtime, updatedPlaytimeItem, domEvent)
        }
      }
    },
    closePlaytimeForm () {
      if (this.componentUsedInSchedulePage) return

      // Remove empty time tag or 24/7 time tag for player playtimes
      if (this.componentUsedInPlayersPageMenu) {
        this.scheduleTimeList = this.scheduleTimeList.filter((time) => { return ['empty', '24/7'].indexOf(time._edit.title) < 0 })
      }

      this.showNewPlayTimeForm = false
      this.selectedPlaytimeItem = null
      this.emitEvent('PLAYTIME_FORM_CLOSED', {
        scheduleTarget: [],
        playtimes: this.scheduleTimeList,
        actionType: null,
        domEvent: 'playTimeFormClosed'
      })
    },
    ...mapActions([
      'setPreferredTimeSystem'
    ])
  },
  mounted () {
    $(window).on('click', (el) => {
      const targetEl = $(el.target)

      // Close playtime form if clicked outside
      const classNameExcep = ['media-row-item-cover', 'prevent-confirm-playtime-form', 'selected-player-name']
      const countClassNameExcep = () => {
        let countCLname = 0
        classNameExcep.forEach((cName) => { if (targetEl.hasClass(cName)) countCLname += 1 })
        return countCLname
      }

      // Check if the clicked element is inside playtime-datetime-picker elements
      let clckedInsdeDateTimePicker = false
      const datetimePickerEls = document.querySelectorAll('.playtime-datetime-picker')
      for (const element of datetimePickerEls) {
        if (element === el.target || element.contains(el.target)) {
          clckedInsdeDateTimePicker = true
          break
        }
      }

      if (countClassNameExcep() < 1 && !clckedInsdeDateTimePicker) {
        const playtimeFormEl = $('#playtimeForm')
        if (playtimeFormEl.length > 0) this.closePlaytimeForm()
      }

      // Close timeTags Dropdown if clicked outside
      const cNameExceptToHideSelBox = ['media-row-item-cover', 'create-new-playtime-btn']
      const countCNameExceptToHideSelBox = () => {
        let count = 0
        cNameExceptToHideSelBox.forEach((cName) => { if (targetEl.hasClass(cName)) count += 1 })
        return count
      }

      if (countCNameExceptToHideSelBox() < 1) {
        const timeTagSelectBoxInput = $('.time-tag-selectbox')

        if (timeTagSelectBoxInput.length) {
          this.timeTagShowSelectbox = false
        }
      }
    })

    this.handleMediaPropertiesFormDataChangedFromParent(this.mediaPropertiesFormDataProp)
    this.setPreferredTimeSystem(this.$dataStore.getPreferredTimeFormat())
  }
}
